import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { IsAuthorized } from "../../utils/helpers/auth";
import { routeUrls } from "../../config/routeUrls";

const AuthLayout: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Check the token
        if (!IsAuthorized()) {
            if (
                location.pathname !== routeUrls.loginCallback && 
                location.pathname !== routeUrls.authorize && 
                location.pathname !== routeUrls.authorizeError &&
                location.pathname !== routeUrls.logout
            ) {
                // Save the current URL for redirect after login
                if (!sessionStorage.getItem("redirectUrl")) {
                    sessionStorage.setItem("redirectUrl", location.pathname);
                    console.log("AuthLayout: Saved redirectUrl:", location.pathname);
                }
                navigate(routeUrls.authorize);
            }
        }
    }, [location]);    

    return (
        <Outlet />
    );
}

export default AuthLayout;